<template>
  <v-treeview open-all :items="items">
    <template v-slot:label="{ item }">
      <div
        style="border-radius: 4px"
        class="d-flex justify-space-between align-center px-1"
        :class="item.classText"
      >
        <p class="subheading mb-0" style="max-width: fit-content" :class="item.class">
          {{ item.name }}
        </p>
        <p class="subheading mb-0" style="max-width: fit-content">
          <b>{{ self[item.value] | numeral("0,0") }}</b>
        </p>
      </div>
    </template>
  </v-treeview>
</template>

<script>
import gsap from "gsap";
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notLocated: 0,
      withoutContacts: 0,
      notLocatedBlocked: 0,
      notLocatedChecked: 0,
      notLocatedBlacklist: 0,
      notLocatedUnchecked: 0,
      notLocatedQuarentine: 0,
      notLocatedApproachable: 0,
      notLocatedDealsBlocked: 0,
      notLocatedWithoutDeals: 0,
      notLocatedNotNotifiable: 0,
      notLocatedNotApproachable: 0,
      notLocatedRecentlyWhatsappOptin: 0,
      notLocatedWhatsappOptin: 0,
      notLocatedWhatsappOptout: 0,
      notLocatedDealsWithout_op: 0,
      notLocatedDealsWithoutPolicy: 0,
      items: [
        {
          name: "Não localizados",
          value: "animatedNotLocated",
          class: "font-weight-bold",
          children: [
            {
              name: "Negociáveis",
              value: "animatedNotLocatedApproachable",
              class: "font-weight-medium",
              classText: "green lighten-5 green--text text--darken-2",
              children: [
                {
                  name: "Com contatos importados e verificados",
                  value: "animatedNotLocatedChecked",
                },
                {
                  name: "Com somente contatos não verificados",
                  value: "animatedNotLocatedUnchecked",
                },
                {
                  name: "Whatsapp Opt-in recentes",
                  value: "animatedNotLocatedRecentlyWhatsappOptin",
                },
                {
                  name: "Whatsapp Opt-in",
                  value: "animatedNotLocatedWhatsappOptin",
                },
                {
                  name: "Whatsapp Opt-out",
                  value: "animatedNotLocatedWhatsappOptout",
                },
              ],
            },
            {
              name: "Não negociáveis",
              value: "animatedNotLocatedNotApproachable",
              class: "font-weight-medium",
              classText: "red lighten-5 red--text text--darken-2",
              children: [
                {
                  name: "Blacklist",
                  value: "animatedNotLocatedBlacklist",
                },
                {
                  name: "Quarentena",
                  value: "animatedNotLocatedQuarentine",
                },
                {
                  name: "Bloqueados",
                  value: "animatedNotLocatedBlocked",
                },
                {
                  name: "Com dívidas bloqueadas",
                  value: "animatedNotLocatedDealsBlocked",
                },
                {
                  name: "Com dívidas sem operações",
                  value: "animatedNotLocatedDealsWithout_op",
                },
                {
                  name: "Com dívidas sem política",
                  value: "animatedNotLocatedDealsWithoutPolicy",
                },
                {
                  name: "Sem dívida",
                  value: "animatedNotLocatedWithoutDeals",
                },
                {
                  name: "Não notificáveis",
                  value: "animatedNotLocatedNotNotifiable",
                },
                {
                  name: "Sem contatos acionáveis",
                  value: "animatedWithoutContacts",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    self() {
      return this;
    },
    animatedNotLocated() {
      return this.notLocated.toFixed(0);
    },
    animatedNotLocatedApproachable() {
      return this.notLocatedApproachable.toFixed(0);
    },
    animatedNotLocatedChecked() {
      return this.notLocatedChecked.toFixed(0);
    },
    animatedNotLocatedUnchecked() {
      return this.notLocatedUnchecked.toFixed(0);
    },
    animatedNotLocatedNotApproachable() {
      return this.notLocatedNotApproachable.toFixed(0);
    },
    animatedNotLocatedRecentlyWhatsappOptin() {
      return this.notLocatedRecentlyWhatsappOptin.toFixed(0);
    },
    animatedNotLocatedWhatsappOptin() {
      return this.notLocatedWhatsappOptin.toFixed(0);
    },
    animatedNotLocatedWhatsappOptout() {
      return this.notLocatedWhatsappOptout.toFixed(0);
    },
    animatedNotLocatedBlacklist() {
      return this.notLocatedBlacklist.toFixed(0);
    },
    animatedNotLocatedQuarentine() {
      return this.notLocatedQuarentine.toFixed(0);
    },
    animatedNotLocatedBlocked() {
      return this.notLocatedBlocked.toFixed(0);
    },
    animatedNotLocatedDealsBlocked() {
      return this.notLocatedDealsBlocked.toFixed(0);
    },
    animatedNotLocatedDealsWithout_op() {
      return this.notLocatedDealsWithout_op.toFixed(0);
    },
    animatedNotLocatedDealsWithoutPolicy() {
      return this.notLocatedDealsWithoutPolicy.toFixed(0);
    },
    animatedNotLocatedWithoutDeals() {
      return this.notLocatedWithoutDeals.toFixed(0);
    },
    animatedNotLocatedNotNotifiable() {
      return this.notLocatedNotNotifiable.toFixed(0);
    },
    animatedWithoutContacts() {
      return this.withoutContacts.toFixed(0);
    },
  },
  watch: {
    "data.not_located"(newValue) {
      gsap.to(this.$data, { duration: 0.5, notLocated: newValue ? newValue : 0 });
    },
    "data.not_located_approachable"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedApproachable: newValue ? newValue : 0,
      });
      let others = newValue - this.data.customer_unchecked;
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedChecked: others ? others : 0,
      });
    },
    "data.customer_unchecked"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedUnchecked: newValue ? newValue : 0,
      });
    },
    "data.not_located_recently_whatsapp_optin"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedRecentlyWhatsappOptin: newValue ? newValue : 0,
      });
    },
    "data.not_located_whatsapp_optin"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedWhatsappOptin: newValue ? newValue : 0,
      });
    },
    "data.not_located_whatsapp_optout"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedWhatsappOptout: newValue ? newValue : 0,
      });
    },
    "data.not_located_not_approachable"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedNotApproachable: newValue ? newValue : 0,
      });
    },
    "data.not_located_blacklist"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedBlacklist: newValue ? newValue : 0,
      });
    },
    "data.not_located_quarentine"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedQuarentine: newValue ? newValue : 0,
      });
    },
    "data.not_located_blocked"(newValue) {
      gsap.to(this.$data, { duration: 0.5, notLocatedBlocked: newValue ? newValue : 0 });
    },
    "data.not_located_deals_blocked"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedDealsBlocked: newValue ? newValue : 0,
      });
    },
    "data.not_located_deals_without_op"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedDealsWithout_op: newValue ? newValue : 0,
      });
    },
    "data.not_located_deals_without_policy"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedDealsWithoutPolicy: newValue ? newValue : 0,
      });
    },
    "data.not_located_without_deals"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedWithoutDeals: newValue ? newValue : 0,
      });
    },
    "data.not_located_not_notifiable"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        notLocatedNotNotifiable: newValue ? newValue : 0,
      });
    },
    "data.without_contacts"(newValue) {
      gsap.to(this.$data, { duration: 0.5, withoutContacts: newValue ? newValue : 0 });
    },
  },
};
</script>

<style></style>
